import { Pipe, PipeTransform } from "@angular/core";
import { ShopsData } from "../../providers/shops";
import { Observable } from 'rxjs/Observable';

@Pipe({
  name: "shopById"
})
export class ShopPipe implements PipeTransform {
  constructor(private shopData: ShopsData) {}

  transform(idShop: string = null, idClient: string): Observable<any> {
    if (idShop) {
      return this.shopData.getClientShopById(idClient, idShop);
    } else {
      return Observable.empty();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/shop/shop.ts